import type { EnemyKind, SkillSpec, StageSpec } from "./types";

export const UNIT_MAX_HP: Record<EnemyKind | "hero", number> = {
  hero: 160,
  swordsman: 24,
  lancer: 30,
  archer: 20,
  monster: 58,
  mountedBoss: 420,
};

export const SKILLS: SkillSpec[] = [
  { id: "weak", key: "J", label: "J", title: "燕返し", cooldown: 0.2, damage: 34, range: 2.2, launch: 10.5, vertical: 5.8, color: 0xeaffb3 },
  { id: "mid", key: "K", label: "K", title: "半月断", cooldown: 0.26, damage: 48, range: 2.9, launch: 15.5, vertical: 7.8, color: 0xffd86a },
  { id: "long", key: "U", label: "U", title: "翠雷術", cooldown: 2.4, damage: 54, range: 2.4, launch: 18, vertical: 9, color: 0x65ffe1 },
  { id: "area", key: "I", label: "I", title: "千葉嵐", cooldown: 2.2, damage: 58, range: 2.0, launch: 22, vertical: 10, color: 0xffd66e },
  { id: "engage", key: "SPACE", label: "空白", title: "瞬・踏込", cooldown: 1.25, damage: 64, range: 7.8, launch: 22, vertical: 14.5, color: 0xdfff65 },
  { id: "disengage", key: "SHIFT", label: "⇧", title: "霞抜け", cooldown: 1.9, damage: 34, range: 3.8, launch: 15, vertical: 10, color: 0xbfa7ff },
];

export const STAGES: StageSpec[] = [
  {
    id: 1, title: "若竹ヶ原", subtitle: "第一陣・包囲突破", description: "溜め薙ぎで道を開き、旗頭を討て",
    palette: ["#4e7d43", "#73a95c", "#b8df7d", "#fff0ad"],
    enemies: { swordsman: 34, lancer: 20, archer: 16, monster: 2, mountedBoss: 0 }, timeLimit: 155, worldWidth: 34, worldHeight: 22,
    waves: [
      { swordsman: 18, lancer: 10, archer: 8, monster: 0, mountedBoss: 0 },
      { swordsman: 16, lancer: 10, archer: 8, monster: 2, mountedBoss: 0 },
    ],
  },
  {
    id: 2, title: "水鏡の渡し", subtitle: "第二陣・矢雨", description: "斬で矢を返し、弓隊の旗頭を討て",
    palette: ["#356f78", "#5e9ca1", "#a6d8bd", "#fff0bd"],
    enemies: { swordsman: 28, lancer: 20, archer: 32, monster: 4, mountedBoss: 0 }, timeLimit: 180, worldWidth: 38, worldHeight: 24,
    waves: [
      { swordsman: 14, lancer: 10, archer: 16, monster: 2, mountedBoss: 0 },
      { swordsman: 14, lancer: 10, archer: 16, monster: 2, mountedBoss: 0 },
    ],
  },
  {
    id: 3, title: "朱槍砦", subtitle: "第三陣・槍衾", description: "槍の予告を見切り、返し一閃で崩せ",
    palette: ["#8b4c34", "#b96849", "#e6a85e", "#ffe5ad"],
    enemies: { swordsman: 36, lancer: 40, archer: 33, monster: 7, mountedBoss: 0 }, timeLimit: 205, worldWidth: 40, worldHeight: 25,
    waves: [
      { swordsman: 14, lancer: 13, archer: 10, monster: 2, mountedBoss: 0 },
      { swordsman: 12, lancer: 14, archer: 11, monster: 2, mountedBoss: 0 },
      { swordsman: 10, lancer: 13, archer: 12, monster: 3, mountedBoss: 0 },
    ],
  },
  {
    id: 4, title: "月蝕鬼門", subtitle: "最終陣・百鬼夜行", description: "鬼軍を崩し、騎将の突進を見切れ",
    palette: ["#554f7e", "#7771a3", "#bd7da0", "#f8dda5"],
    enemies: { swordsman: 36, lancer: 40, archer: 45, monster: 11, mountedBoss: 1 }, timeLimit: 250, worldWidth: 44, worldHeight: 27,
    waves: [
      { swordsman: 14, lancer: 12, archer: 15, monster: 3, mountedBoss: 0 },
      { swordsman: 12, lancer: 14, archer: 15, monster: 4, mountedBoss: 0 },
      { swordsman: 10, lancer: 14, archer: 15, monster: 4, mountedBoss: 1 },
    ],
  },
];
